import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataMember } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_MEMBER = defineMasterdataEntity<MasterdataMember>({
  name: 'member',
  responseKey: 'members',
  displayWith: (m) => keyName(m.key, m.name),
  secondaryWith: (m) =>
    [m.contact?.zipCode, m.contact?.location].filter(Boolean).join(' ') || null,
  icon: 'fa-regular fa-address-card',
  title: 'Mitgliedersuche',
  label: 'Mitglied',
  placeholder: 'Mitglied suchen...',
  columns: [
    {
      label: 'Mitglied',
      type: 'entity',
      icon: 'fa-regular fa-address-card',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) =>
        [e.contact?.zipCode, e.contact?.location].filter(Boolean).join(' ') ||
        null,
    },
    { label: 'Nr.', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Lieferant', type: 'text', value: (e) => e.supplier?.name ?? null },
    { label: 'Bezirk', type: 'text', value: (e) => e.district?.name ?? null },
    { label: 'Funktion', type: 'text', value: (e) => e.function },
    { label: 'Straße', type: 'text', value: (e) => e.contact?.street ?? null },
    { label: 'PLZ', type: 'text', value: (e) => e.contact?.zipCode ?? null },
    { label: 'Ort', type: 'text', value: (e) => e.contact?.location ?? null },
    { label: 'Gültig ab', type: 'text', value: (e) => e.validFrom },
  ],
});
